<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener('DOMContentLoaded',function(){
    var links = document.links;
    for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
        if (links[i].hostname != window.location.hostname && links[i].hostname != '' && link.hostname !== 'account-hotel-us.gflcosmetics.com') {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener';
        }
    }
});

function sendtome(formemail,variantid,varianturl){
  $.post( "https://zamliy3.zamliy.com/oos.php?prid=X&variantid="+variantid+"&email="+formemail+"&mySite=HotelUS&url="+varianturl, function( data ) {
    $( ".result" ).html( data );
  });
}